import { render } from "./HeaderBar.vue?vue&type=template&id=2655f56c"
import script from "./HeaderBar.vue?vue&type=script&lang=js"
export * from "./HeaderBar.vue?vue&type=script&lang=js"

import "./HeaderBar.vue?vue&type=style&index=0&id=2655f56c&lang=css"
script.render = render

export default script